
import { Component, Prop, Vue } from "vue-property-decorator";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {IFindDriver} from "@/modules/FindDriver/interfaces/find-driver.interface";

@Component({})
export default class ActionsCell extends Vue {
  @Prop() cell: IAppTable.ITableProp;
  @Prop() entity: IFindDriver.ITableEntity;
  @Prop() index: number;

  get phone() {
    return this.entity.phone ? this.entity.phone.trim() : '';
  }

}
